import {
  Box,
  Tooltip,
 // Badge,
  tooltipClasses,
  styled,
 // useTheme
} from '@mui/material';
import { Link } from 'react-router-dom';
import Logo_ from '../../assets/images/logo/logo192.png';

const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: 53px;
        margin: 0 auto;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const TooltipWrapper = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.colors.alpha.trueWhite[100],
    color: theme.palette.getContrastText(theme.colors.alpha.trueWhite[100]),
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    borderRadius: theme.general.borderRadiusSm,
    boxShadow:
      '0 .2rem .8rem rgba(7,9,25,.18), 0 .08rem .15rem rgba(7,9,25,.15)'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.colors.alpha.trueWhite[100]
  }
}));

// `responsive` (en-tête) : l'image garde ses proportions et rétrécit avec l'écran au lieu de
// déborder d'un conteneur de 53 px avec un décalage de −80 px, qui la faisait passer sous
// les boutons de l'en-tête sur mobile. Sans ce prop, rendu inchangé pour les autres pages.
function Logo({ responsive = false }) {
 // const theme = useTheme();

  return (
    <TooltipWrapper
      title="Home"
      arrow
    >
      {responsive ? (
        <Link to="/dashboards/tasks" style={{ display: 'flex', alignItems: 'center', minWidth: 0 }}>
          {/* Hauteur fixe par point de rupture (et non en `vw`) : le logo ne change de taille
              qu'aux paliers téléphone / tablette / ordinateur, pas à chaque pixel. */}
          <Box
            component="img"
            alt=""
            src={Logo_}
            sx={{ height: { xs: 32, sm: 44, md: 60 }, width: 'auto', maxWidth: '100%', objectFit: 'contain', display: 'block', flexShrink: 0 }}
          />
        </Link>
      ) : (
        <LogoWrapper to="/dashboards/tasks">
                <img style={{marginLeft:-80, height:60}} alt="" src={Logo_}/>
        </LogoWrapper>
      )}
    </TooltipWrapper>
  );
}

export default Logo;
